export default __webpack_public_path__ + "static/media/icon_heart.6f61aa31.svg";